var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2669 18.1173C15.1002 18.1007 14.9002 18.1007 14.7169 18.1173C10.7502 17.984 7.60023 14.734 7.60023 10.734C7.60023 6.65065 10.9002 3.33398 15.0002 3.33398C19.0836 3.33398 22.4002 6.65065 22.4002 10.734C22.3836 14.734 19.2336 17.984 15.2669 18.1173Z",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3497 6.66602C30.583 6.66602 33.183 9.28268 33.183 12.4993C33.183 15.6493 30.683 18.216 27.5664 18.3327C27.433 18.316 27.283 18.316 27.133 18.3327",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93382 24.266C2.90049 26.966 2.90049 31.366 6.93382 34.0493C11.5172 37.116 19.0338 37.116 23.6172 34.0493C27.6505 31.3493 27.6505 26.9493 23.6172 24.266C19.0505 21.216 11.5338 21.216 6.93382 24.266Z",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5664 33.334C31.7664 33.084 32.8997 32.6006 33.8331 31.884C36.4331 29.934 36.4331 26.7173 33.8331 24.7673C32.9164 24.0673 31.7997 23.6007 30.6164 23.334",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.de7c9a0a575a574cb986da9dadb786db.svg";
export { ForwardRef as ReactComponent };